import axios from 'axios';

export default {
    getUser (id, scheme, success, fail) {
        if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_USE_DUMMY_DATA === 'true') {
            return axios.get('/dummy-member.json').then((response) => {
                success(JSON.stringify(response.data));
                return response.data;
            }, (response) => {
                fail(response);
            });
        }
        axios.get('/api/users/'+ id + '/' + scheme).then((response) => {
            success(response.data);
        }, (response) => {
            fail(response);
        });
    },
    getIsRegistered () {
        if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_USE_DUMMY_DATA === 'true') return Promise.resolve(true);
        return axios.get('/api/isRegistered/').then((response) => {
            return response.data;
        }, (response) => {
            return response;
        });
    },
    getCanRegister () {
        if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_USE_DUMMY_DATA === 'true') return Promise.resolve(true);
        return axios.get('/api/canRegister/').then((response) => {
            return response.data;
        }, (response) => {
            return response;
        });
    },
    registerUser (registrationDetails) {
        if (process.env.NODE_ENV === 'development' && process.env.VUE_APP_USE_DUMMY_DATA === 'true') return Promise.resolve(true);
        return axios.post('/api/register/', registrationDetails).then((response) => {
            return response.data;
        }, (response) => {
            return response;
        });
    }
};
